import { render } from "./SignInPage.vue?vue&type=template&id=208a059f&scoped=true&ts=true"
import script from "./SignInPage.vue?vue&type=script&lang=ts"
export * from "./SignInPage.vue?vue&type=script&lang=ts"

import "./SignInPage.vue?vue&type=style&index=0&id=208a059f&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208a059f"]])

export default __exports__